import { DemoSelectControl } from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Item from './Item';
import Output from './Output';

function JustifyAndAlign() {
  return (
    <FlexDemo
      initialValues={{
        '--direction': 'row',
        '--justify': 'flex-start',
        '--align-items': 'stretch',
        showAxisLabels: false,
      }}
      customGrid={{
        gridTemplateColumns: '1fr 1fr 1fr',
      }}
      controls={[
        <DemoSelectControl
          key="--direction"
          id="--direction"
          label="flex-direction"
          options={['row', 'column']}
        />,
        <DemoSelectControl
          key="--justify"
          id="--justify"
          label="justify-content"
          options={[
            'flex-start',
            'center',
            'flex-end',
            'space-between',
            'space-around',
            'space-evenly',
          ]}
        />,
        <DemoSelectControl
          isNew
          key="--align-items"
          id="--align-items"
          label="align-items"
          options={[
            'stretch',
            'flex-start',
            'center',
            'flex-end',
            'baseline',
          ]}
        />,
      ]}
    >
      {(state) => (
        <Output state={state}>
          <Item style={{ fontSize: '1.375rem' }}>Hello</Item>
          <Item>to</Item>
          <Item>the</Item>
          <Item style={{ fontSize: '1.375rem' }}>World</Item>
        </Output>
      )}
    </FlexDemo>
  );
}

export default JustifyAndAlign;
